import { create } from 'zustand'

import { type CoreProductSelection, type ParameterID } from '@flecto/types'

interface ProductSelectionState {
  itemsSelectionMap: Map<ParameterID, CoreProductSelection> | undefined
  setItemsSelectionMap: (
    map: Map<ParameterID, CoreProductSelection> | undefined
  ) => void
}

export const useProductSelectionStore = create<ProductSelectionState>(
  (set) => ({
    itemsSelectionMap: undefined,
    setItemsSelectionMap: (map) => set({ itemsSelectionMap: map }),
  })
)
